import { ContextAware, DetailContext } from "@/app/contexts/detail.context";
import { getObjectContentsFromPath } from "@/app/helpers/stringpath.helper";
import Vue from "vue";
import store from "@/store";
import {resolveEngine} from "@/app/helpers/resolve.engine";

export class ExternalContext implements ContextAware{
  data: { [key: string]: any } = {};
  public setData(key: string, rule: any): ExternalContext {
    this.data[key] = rule;
    return this;
  }


  constructor() {
    this.setData("activity", store.state.activity.currentActivityDefinition);
    this.setData("activitydefinition", store.state.activity.currentActivityDefinition);
    const user = store.state.user;
    this.setData("user", {
      contactId: user.contactId,
      organizationId: user.organizationId,
      language: user.language,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      roles: user.activityRoles,
      roleIds: user.activityRoleIds
    });
    this.setData("bccaId", store.state.appConfig.bccaId);
  }

  public resolvePlaceholders(data: any): any {
    return resolveEngine.resolvePlaceholders(data, this);
  }

  public resolveFieldValue(dataPath: string): any {
    return resolveEngine.resolveFieldValue(dataPath, this);
  }

  public inherit(
    detailContext: DetailContext | ExternalContext
  ): ExternalContext {
    if (!detailContext || !detailContext.data) return this;
    Object.entries(detailContext.data).forEach((value) => {
      this.data[value[0]] = value[1];
    });
    return this;
  }

  getData(): { [p: string]: any } {
    return this.data;
  }
}
